import { useMutation, useQueryClient } from '@tanstack/react-query';
import { converters as filesConverters } from 'store/files';
// circular dependency
import { shopKeys } from 'store/shop/shop.queries';
import { loaders } from './benefits.loaders';
import { benefitsKeys } from './benefits.queries';

export const useExportToXls = () => {
  return useMutation(loaders.exportXls, {
    onSuccess: filesConverters.export,
  });
};

export const useCreateBenefit = () => {
  const queryClient = useQueryClient();

  return useMutation(loaders.createBenefit, {
    onSuccess: () => {
      return queryClient.invalidateQueries(benefitsKeys.all);
    },
  });
};

export const useUpdateBenefit = () => {
  const queryClient = useQueryClient();

  return useMutation(loaders.updateBenefit, {
    onSuccess: () => {
      return queryClient.invalidateQueries(benefitsKeys.all);
    },
  });
};

export const useUpdateBenefitContent = () => {
  const queryClient = useQueryClient();

  return useMutation(loaders.updateBenefitContent, {
    onSuccess: () => {
      return queryClient.invalidateQueries(benefitsKeys.all);
    },
  });
};

export const useCopyBenefit = () => {
  const queryClient = useQueryClient();

  return useMutation(loaders.copyBenefit, {
    onSuccess: () => {
      return queryClient.invalidateQueries(benefitsKeys.lists);
    },
  });
};

export const useDeleteBenefit = () => {
  const queryClient = useQueryClient();

  return useMutation(loaders.deleteBenefit, {
    onSuccess: () => {
      return queryClient.invalidateQueries(benefitsKeys.lists);
    },
  });
};

export const useBulkUpdateBenefits = () => {
  const queryClient = useQueryClient();

  return useMutation(loaders.bulkUpdate, {
    onSuccess: () => {
      return queryClient.invalidateQueries(benefitsKeys.all);
    },
  });
};

export const useUpdateCategoryContent = () => {
  const queryClient = useQueryClient();

  return useMutation(loaders.updateCategoryContent, {
    onSuccess: () => {
      return queryClient.invalidateQueries(benefitsKeys.all);
    },
  });
};

export const useAssignShopItem = () => {
  const queryClient = useQueryClient();

  return useMutation(loaders.assignShopItem, {
    onSuccess: (_, { benefitId }) => {
      return Promise.all([
        queryClient.invalidateQueries(benefitsKeys.all),
        queryClient.invalidateQueries(shopKeys.list(benefitId)),
      ]);
    },
  });
};

export const useUnassignShopItem = () => {
  const queryClient = useQueryClient();

  return useMutation(loaders.unassignShopItem, {
    onSuccess: (_, { benefitId }) => {
      return Promise.all([
        queryClient.invalidateQueries(benefitsKeys.all),
        queryClient.invalidateQueries(shopKeys.list(benefitId)),
      ]);
    },
  });
};

export const useAssignShopItems = () => {
  const queryClient = useQueryClient();

  return useMutation(loaders.assignShopItems, {
    onSuccess: (_, { benefitId }) => {
      return Promise.all([
        queryClient.invalidateQueries(benefitsKeys.all),
        queryClient.invalidateQueries(shopKeys.list(benefitId)),
      ]);
    },
  });
};

export const useUnassignShopItems = () => {
  const queryClient = useQueryClient();

  return useMutation(loaders.unassignShopItems, {
    onSuccess: (_, { benefitId }) => {
      return Promise.all([
        queryClient.invalidateQueries(benefitsKeys.all),
        queryClient.invalidateQueries(shopKeys.list(benefitId)),
      ]);
    },
  });
};

export const useUpdateShopItemsConfig = () => {
  const queryClient = useQueryClient();

  return useMutation(loaders.updateShopItemsConfig, {
    onSuccess: (_, { benefitId }) => {
      return Promise.all([
        queryClient.invalidateQueries(benefitsKeys.all),
        queryClient.invalidateQueries(shopKeys.list(benefitId)),
      ]);
    },
  });
};

export const useRemoveShopItemsConfig = () => {
  const queryClient = useQueryClient();

  return useMutation(loaders.removeShopItemsConfig, {
    onSuccess: (_, { benefitId }) => {
      return Promise.all([
        queryClient.invalidateQueries(benefitsKeys.all),
        queryClient.invalidateQueries(shopKeys.list(benefitId)),
      ]);
    },
  });
};

export const useLinkSelection = () => {
  const queryClient = useQueryClient();

  return useMutation(loaders.linkSelection, {
    onSuccess: () => {
      return Promise.all([
        queryClient.invalidateQueries(benefitsKeys.all),
        queryClient.invalidateQueries(shopKeys.lists),
      ]);
    },
  });
};
